import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "5px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
  },
}));

const StyledRadioMain = styled("div")(({ theme }) => ({
  marginTop: "30px",
  "& .container": {
    display: "block",
    position: "relative",
    paddingLeft: "35px",
    marginBottom: "12px",
    cursor: "pointer",
    userSelect: "none",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    // lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& .container input": { position: "absolute", opacity: 0, cursor: "pointer" },
  "& .checkmark": {
    position: "absolute",
    top: "4px",
    left: "0",
    height: "20px",
    width: "20px",
    backgroundColor: "#fff",
    border: "2px solid #0B0B0B",
    borderRadius: "50%",
  },
  "& .container input:checked ~ .checkmark:after": {
    content: '""',
    position: "absolute",
    display: "block",
    top: "-1px",
    left: "-1px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#0B0B0B",
    zIndex: 1,
  },
  ".icon": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "16px",
    height: "16px",
    color: "#fff",
    display: "none",
    zIndex: 2,
  },
  ".container input:checked ~ .checkmark .icon": { display: "block" },
}));

export { Header, Linked, Maincontant, StyledRadioMain };
